<template>

    <div class="fuid-langsitcher">

        <ul class="fuid-langsitcher__ul d-flex">

            <li v-for="(lang, i) in langs"
                :key="`Lang${i}`"
                class="fuid-langsitcher__li d-none d-md-flex align-items-center justify-content-center"
                :class="$i18n.locale == lang ? 'active' : 'inactive'"
                @click.prevent="switchLocale(lang)"
            >{{ lang }}</li>

        </ul>

    </div>

</template>

<script>

    import { mapActions } from 'vuex'
    import { mapGetters } from 'vuex'

    export default {

        data () {

            return {

                langs: this.$i18n.availableLocales

            }
            
        },

        computed: {

            ...mapGetters('Prematriculas', ['getGroupIncrement']),
            ...mapGetters('Prematriculas', ['getGroupIncrement2']),
            ...mapGetters('Prematriculas', ['getAlumnosIds']),
            ...mapGetters('Matricula', ['getPaymentType']),

        },

        methods: {

            ...mapActions('Prematriculas', ['regenerateSelectData']),

            switchLocale(lang){

                this.$i18n.locale = lang

                this.$store.commit('Prematriculas/SET_LOCALE', lang)

                // If there are selects update the texts
                if( this.getAlumnosIds.length > 0 ) this.regenerateSelectData( { increment: this.getGroupIncrement, increment2: this.getGroupIncrement2, paymentType: this.getPaymentType } )

            }

        }

    }
</script>

<style lang="scss" scoped>

</style>